import { render, staticRenderFns } from "./DynamicObjectDetail.vue?vue&type=template&id=56175ca2"
import script from "./DynamicObjectDetail.vue?vue&type=script&lang=js"
export * from "./DynamicObjectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports